'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const theme_Animation = require('../../../theme/Animation.cjs.js');
require('../../../theme/Colors.cjs.js');
const theme_Shadows = require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
require('react');
const components_navigation_Link_Link = require('../Link/Link.cjs.js');
const utils_createUniqueCustomProperty = require('../../../utils/createUniqueCustomProperty.cjs.js');
const components_navigation_InteractiveTag_InteractiveTagContext = require('./InteractiveTagContext.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Vars = utils_createUniqueCustomProperty.createUniqueCustomProperties("InteractiveTagWrapper", [
  "backgroundColor",
  "backgroundColorHover",
  "backgroundColorFocus",
  "color",
  "colorHover",
  "colorFocus",
  "outlineColor",
  "outlineOpacity"
]);
const Styles = styleEncapsulation.labelStyles("InteractiveTag", {
  root: (maxWidth) => react.css`
    ${styleMixins_reset.boxSizing};
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--zds-space-8);
    height: var(--zds-size-medium);
    max-width: ${maxWidth};
    padding: var(--zds-space-12);
    font: var(--zds-body-3);
    color: var(${Vars.color});
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    background-color: var(${Vars.backgroundColor});
    border-radius: var(--zds-radius-pill);
    transition: ${theme_Animation.Animation.transitionValue};

    &:hover {
      color: var(${Vars.colorHover});
      background-color: var(${Vars.backgroundColorHover});
      box-shadow: ${theme_Shadows.Shadows.elevation6};
    }

    &:focus-visible,
    a:focus-visible & {
      color: var(${Vars.colorFocus});
      background-color: var(${Vars.backgroundColorFocus});
      ${Vars.outlineOpacity}: 1;
      outline: none;

      &::before {
        inset: -4px;
      }
    }

    &[data-color='primary'] {
      border: var(--zds-border-default);
      ${Vars.color}: var(--zds-gray-warm-10);
      ${Vars.colorHover}: var(--zds-text-stronger);
      ${Vars.colorFocus}: var(--zds-text-stronger);
      ${Vars.outlineColor}: var(--zds-text-stronger);
      ${Vars.backgroundColor}: var(--zds-background-stronger);
      ${Vars.backgroundColorHover}: var(--zds-background-stronger);
      ${Vars.backgroundColorFocus}: var(--zds-background-stronger);

      &:hover {
        border-color: var(--zds-stroke-stronger);
      }

      &:focus-visible,
      a:focus-visible & {
        border-color: var(--zds-stroke-stronger);
        outline: none;

        &::before {
          inset: -4px;
        }
      }
    }

    &[data-color='secondary'] {
      border: var(--zds-border-width-default) solid var(--zds-gray-warm-10);
      ${Vars.color}: var(--zds-text-inverted);
      ${Vars.colorHover}: var(--zds-background-weaker);
      ${Vars.colorFocus}: var(--zds-background-weaker);
      ${Vars.backgroundColor}: var(--zds-gray-warm-10);
      ${Vars.outlineColor}: var(--zds-gray-warm-10);
      ${Vars.backgroundColorHover}: var(--zds-gray-warm-9);
      ${Vars.backgroundColorFocus}: var(--zds-gray-warm-10);
    }

    &::before {
      content: '';
      opacity: var(${Vars.outlineOpacity}, 0);
      position: absolute;
      inset: 0;
      border: 2px solid var(${Vars.outlineColor});
      border-radius: inherit;
      transition: inherit;
    }
  `
});
const InteractiveTagWrapper = ({ children, color, href, onClick, maxWidth = "none" }) => {
  const sharedProps = {
    css: Styles.root(maxWidth),
    "data-color": color,
    onClick
  };
  const WrappedChildren = () => {
    if (href) {
      return react.jsx(components_navigation_Link_Link.Link, Object.assign({}, sharedProps, { color: null, href, weight: null }), children);
    }
    return react.jsx("button", Object.assign({}, sharedProps, { type: "button", "data-zds": true }), children);
  };
  return react.jsx(
    components_navigation_InteractiveTag_InteractiveTagContext.InteractiveTagProvider,
    null,
    react.jsx(components_navigation_InteractiveTag_InteractiveTagContext.InteractiveTagContext.Consumer, null, (context) => {
      return (context === null || context === void 0 ? void 0 : context.isTruncated) ? react.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { allowMultilineTooltip: true, content: context.body ? `${context.title}: ${context.body}` : `${context.title}`, shouldCorrectPosition: true }, () => react.jsx(WrappedChildren, null)) : react.jsx(WrappedChildren, null);
    })
  );
};

exports.InteractiveTagWrapper = InteractiveTagWrapper;
//# sourceMappingURL=InteractiveTagWrapper.cjs.js.map
